export default "__VITE_ASSET__eX8RBecH__"